import { render, staticRenderFns } from "./invoices-tab.vue?vue&type=template&id=4427d95e&scoped=true&"
import script from "./invoices-tab.vue?vue&type=script&lang=js&"
export * from "./invoices-tab.vue?vue&type=script&lang=js&"
import style0 from "./invoices-tab.vue?vue&type=style&index=0&id=4427d95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427d95e",
  null
  
)

export default component.exports